import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { CollectionService } from '../../../../analytics-settings/services/collection.service';
import { UpperCaseFirstLetterPipe } from '../../../../../shared/utils/pipes/upperCaseFirstLetterPipe';
@Component({
  selector: 'app-remove-collection',
  templateUrl: './remove-collection.component.html',
  styleUrls: ['./remove-collection.component.scss']
})
export class RemoveCollectionComponent implements OnInit {

  collection : any = {};
  savingInProgress: boolean;
  constructor(
    private dialogRef: MatDialogRef<RemoveCollectionComponent>,
    private collectionService: CollectionService,
  ) { }

  ngOnInit(): void {
    this.collection = this.dialogRef._containerInstance._config.data;
  }

  closePopup() {
    this.dialogRef.close();
  }

  deleteCollection() {
    this.dialogRef.close();
    this.collectionService.removeCollectionCard(this.collection);
  }

}
